// extracted by mini-css-extract-plugin
export default {"container":"PW-z","title":"QW-z","link":"RW-z"};